import ProductShowcase from '@/components/base/ProductShowcase';
import { avisoImagens, type ProdutoCuradoria } from '@/mocks/curadoria';

interface CuradoriaGaleriaProps {
  eyebrow: string;
  titulo: string;
  descricao: string;
  produtos: ProdutoCuradoria[];
  contexto: string;
  tom?: 'white' | 'soft';
}

/**
 * Galeria de curadoria: grade de 2/3 colunas com imagens grandes,
 * identificação discreta do fabricante e ações simples.
 */
export default function CuradoriaGaleria({
  eyebrow,
  titulo,
  descricao,
  produtos,
  contexto,
  tom = 'white',
}: CuradoriaGaleriaProps) {
  const fundo = tom === 'soft' ? 'bg-background-50' : 'bg-white';

  return (
    <section className={`${fundo} border-t border-background-200`}>
      <div className="max-w-[1360px] mx-auto px-5 md:px-8 xl:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-14 items-end mb-10 md:mb-14">
          <div className="lg:col-span-7">
            <p className="hop-eyebrow text-foreground-400">{eyebrow}</p>
            <h2 className="mt-4 text-[26px] sm:text-[32px] md:text-[40px] leading-[1.08] tracking-[-0.036em] font-semibold text-foreground-950">
              {titulo}
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[14px] md:text-[15px] leading-[1.65] text-foreground-500 max-w-[420px]">
              {descricao}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12 md:gap-x-8 md:gap-y-16">
          {produtos.map((produto) => (
            <ProductShowcase
              key={`${produto.nome}-${produto.referencia ?? produto.paginaPdf}`}
              produto={produto}
              contexto={contexto}
              mostrarValidacao
            />
          ))}
        </div>

        <p className="mt-10 flex items-start gap-2 text-[11.5px] leading-[1.6] text-foreground-400 max-w-[720px]">
          <i className="ri-image-line mt-[1px] text-[13px] text-foreground-300"></i>
          <span>{avisoImagens}</span>
        </p>
      </div>
    </section>
  );
}